var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{attrs:{"href":"https://deguchihi.net"}},[_vm._v("GO TO \"GUI MODE\"↗")]),_c('p',[_vm._v("CUI MODE ")]),_c('p',[_vm._v("Copyright @ hirokideguchi")])])
}]

export { render, staticRenderFns }